import { ICON_TYPES } from '../constants';

export const ArrowRightNormalIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.546 28.044">
      <path d="M16.532,28.042,30.546,14.016,16.53,0l0,4.662,7.489,7.432H0v4H23.406L16.53,22.835v5.209Z" />
    </svg>
  );
};

ArrowRightNormalIcon.iconType = ICON_TYPES.ARROW_RIGHT_NORMAL;
